/*
 * @Author: your name
 * @Date: 2020-09-01 10:37:23
 * @LastEditTime: 2020-09-15 13:32:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/assets/lib/utils.js
 */
import qs from 'qs';
export const getByteLen = (val = '', actualLength) => {
  if (val == '') { return }
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    let a = val.charAt(i);
    if (a.match(/[^\x00-\xff]/ig) != null) {
      len += 2;
    }
    else {
      len += 1;
    }
  }
  return len;
}
export const getLength = (val, valLength) => {
  let csc = ''
  let len = 0
  for (let i = 0; i <= val.length; i++) {
    if (len >= valLength) {
      return csc
    }
    csc += val.charAt(i);
    if (!/^[\u0000-\u00ff]$/.test(val.charAt(i))) {
      len += 2;
    }
    else {
      len += 1;
    }
  }
}

/**
* 获取url参数集合（包含#前后）
* @returns {Object} 返回JSON对象集合
* */
export const getUrlParamsNew = (url) => {
  // let url = window.location.href;
  url = url.replace('/#', '#');
  let arr = url.split('?');
  let obj = {};
  function getObj (url) {
    const str = url;
    let data = {};
    if (str.indexOf('#') > -1) {
      data = qs.parse(str.substring(0, str.indexOf('#')));
    } else {
      data = qs.parse(str);
    }
    return data;
  }
  if (url.indexOf('?') > -1 && arr && arr.length) {
    if (arr && arr.length > 1) {
      arr = arr.slice(1, arr.length);
      arr.forEach(item => {
        obj = Object.assign(obj, getObj(item), false);
      });
      return obj;
    }
    return obj;
  } else {
    return obj;
  }
};


function num (s) {
  return s < 10 ? '0' + s : s
}

// 标准时间转日期 2019-01-28
export const dateTime = (time) => {
  if (!time) {
    return ''
  }
  let t = new Date(time)
  let datetime = ''
  datetime += t.getFullYear()
  datetime += '-' + num(t.getMonth() + 1)
  datetime += '-' + num(t.getDate())
  return datetime
}
// 标准时间转日期 后期会加 时
export const dateTimeH = (time) => {
  if (!time) {
    return ''
  }
  let t = new Date(time)
  let datetime = ''
  datetime += t.getFullYear()
  datetime += '-' + num(t.getMonth() + 1)
  datetime += '-' + num(t.getDate()) + ' '
  datetime += num(t.getHours())
  return datetime
}
// 标准时间转日期 后期会加 时、分
export const dateTimeHs = (time) => {
  if (!time) {
    return ''
  }
  let t = new Date(time)
  let datetime = ''
  datetime += t.getFullYear()
  datetime += '-' + num(t.getMonth() + 1)
  datetime += '-' + num(t.getDate()) + ' '
  datetime += num(t.getHours()) + ':'
  datetime += num(t.getMinutes())
  return datetime
}

/**
 * 获取url中的参数
 * @param name
 * @returns {*}
 */
export const getUrlParam = (name) => {
  var reg = new RegExp('(\\?|&)' + name + '=([^&#]*)(&|#|$)'); //构造一个含有目标参数的正则表达式对象
  var search = window.location.href;
  var r = search.match(reg); //匹配目标参数
  if (r != null) return decodeURI(r[2]);
  return null; //返回参数值
}

/**
 * 判断是否是安卓
 * @returns boolean [ true | false ]
 */
export const isAndroid = () => {
  // 小拉app
  if (getUrlParam('client_type') == 'android_app') {
    return true;
  }
  return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
}

/**
 * 判断是否是ios
 * @returns boolean [ ture  | false ]
 */
export const isiOS = () => {
  return !!navigator.userAgent.match(/(iPad|iPhone|iPod|iOS)/g);
}

/**
 * 判断是否是微信环境
 * @returns boolean [ true | false ]
 */
export const isWixin = () => {
  // 小拉小程序
  if (getUrlParam('client_type') == 'xl_wxa') {
    return true;
  }
  return navigator.userAgent.match(/MicroMessenger/i) == 'micromessenger';
}


/**
 * 判决环境 返回平台类型
 * @returns 
 */
export const queryPlatformType = () => {
  if (isAndroid()) {
    return 'XL_ANDROID'
  }
  if (isiOS()) {
    return 'XL_IOS'
  }
  if (isWixin()) {
    return 'XL_WXA'
  }
  return '';
}

/**
 * 判断是否小拉app
 * @returns boolean [ true | false ]
 */
export const isXLAPP = () => {
  if (getUrlParam('client_type')) {
    return true;
  } else {
    return false
  }
}

function stringifyQuery (obj) {
  return Object.keys(obj)
    .reduce((str, k) => `${str}&${k}=${encodeURIComponent(obj[k])}`, '')
    .slice(1);
}
/**
 * 获取url中的所有参数
 * @param url
 * @returns {oject} 参数名&&参数值
 */
function getQueryArgs (url) {
  if (url.indexOf('?') == -1) return {};
  var qs = url.length > 0 ? url.substring(url.indexOf('?')).substr(1) : '',
    //保存每一项
    args = {},
    //得到每一项
    items = qs.length ? qs.split('&') : [],
    item = null,
    name = null,
    value = null,
    i = 0,
    len = items.length;
  for (i = 0; i < len; i++) {
    (item = items[i].split('=')), (name = decodeURIComponent(item[0]));
    value = decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  }
  return args;
}

/**
 * hll域名之间参数拼接跳转，除uuid
 * @param {string} url1 跳转目的url
 * @param {string} url2 当前页面url
 */
export const urlParamHandle = (url1, url2) => {
  let hash = '';
  let isHashLast = url1.indexOf('#') > url1.indexOf('?');
  let searchObj = {};
  if (isHashLast) {
    searchObj = getQueryArgs(url1.split('#')[0]) || {};
    hash = url1.split('#')[1];
  } else {
    searchObj = getQueryArgs(url1) || {};
  }
  let urlSearch = {};
  let paramsObj = {};
  let jumpUrl = '';
  let domain = url1.indexOf('?') > -1 ? url1.split('?')[0] : url1;
  let regHash = /#\/$/;
  domain = regHash.test(domain) ? domain.slice(0, domain.length - 2) : domain;
  // 获取当前url参数，与输入url参数组合
  urlSearch = url2.indexOf('?') > -1 ? getQueryArgs(url2) : {};
  if (urlSearch._token && !urlSearch.token) urlSearch.token = urlSearch._token;
  if (urlSearch.uuid) {
    delete urlSearch.uuid;
  }
  paramsObj = { ...searchObj, ...urlSearch };
  jumpUrl =
    decodeURIComponent(domain + '?' + stringifyQuery(paramsObj)) +
    (isHashLast ? `#${hash}` : '');
  return jumpUrl;
}





// WEBPACK FOOTER //
// ./src/assets/lib/utils.js